import { useCallback, useEffect, useState } from "react";
import {
  dispatchSelectionHighlightUiState,
  DEFAULT_SELECTION_HIGHLIGHT_UI_STATE,
  type SelectionHighlightTargetType,
} from "./visibilityEvents";

type UseSelectionHighlightControlArgs = {
  targetType: SelectionHighlightTargetType;
  targetId?: string | null;
  disabled?: boolean;
  ensureVisible?: () => void;
};

const rememberedSelectionHighlightState = { ...DEFAULT_SELECTION_HIGHLIGHT_UI_STATE };

export function useSelectionHighlightControl({
  targetType,
  disabled = false,
  ensureVisible,
}: UseSelectionHighlightControlArgs) {
  const [highlight, setHighlight] = useState(() => rememberedSelectionHighlightState[targetType]);

  useEffect(() => {
    setHighlight(rememberedSelectionHighlightState[targetType]);
  }, [targetType]);

  useEffect(() => {
    dispatchSelectionHighlightUiState(targetType, !disabled && highlight);
  }, [targetType, disabled, highlight]);

  const toggleHighlight = useCallback(() => {
    if (disabled) return;
    setHighlight((current) => {
      const next = !current;
      rememberedSelectionHighlightState[targetType] = next;
      if (next) ensureVisible?.();
      return next;
    });
  }, [disabled, ensureVisible, targetType]);

  return {
    highlight,
    toggleHighlight,
  };
}
